import React, { Component } from 'react';
import styled from 'styled-components';
import Img from 'gatsby-image';
import QtySelector from './QtySelector';
import { CommerceButton } from './Buttons';
import { inject, observer } from 'mobx-react';
import { isEmpty } from 'lodash';
import { getFormattedProductPrice } from '../utils/product';

@inject('cart')
@inject('ui')
@observer
class Product extends Component {
  constructor(props) {
    super(props)
    const {product} = props;
    this.state = {
      qty: product.evenQuanitiesOnly ? 2 : 1,
    };
  }

  onAddCartClick = product => {
    const { qty } = this.state;
    const { cart, ui } = this.props;
    if (qty > 0) {
      const payload = { ...product, qty };
      // console.log('adding to cart: ', payload)
      cart.addToCart(payload);
      ui.openCartModal({
        message: 'Sucessfully added to order',
      });
    }
  };

  setQty = qty => {
    this.setState({
      qty,
    });
  };

  render() {
    const { onOpenCustomizeModalClicked, product, ui } = this.props;
    const { image, title, description } = product;
    const disableAddToCart = ui.cartCheckoutDisabled;

    // console.log('product: ', product);
    // console.log('disableAddToCart: ', disableAddToCart);

    return (
      <ProductContainer
        disabled={disableAddToCart}
      >
        { image ? (
          <ProductImageContainer
            showPointer={!disableAddToCart && !isEmpty(product.config)}
            onClick={() => disableAddToCart ? null : onOpenCustomizeModalClicked(product)}
          >
            <Img fluid={image.fluid} />
          </ProductImageContainer>
        ) : null}
        <ContentContainer>
          <Title>{title}</Title>
          { description ? (
            <Description>
              <div
                dangerouslySetInnerHTML={{
                  __html: description.childMarkdownRemark.html,
                }}
              />
            </Description>
          ) : null}
          { disableAddToCart ? null :
            <>
              <Price>{getFormattedProductPrice(product, this.state.qty)}</Price>
              <CommerceItems>
                {!product.catering ? (
                  <>
                    <QtySelector min={product.evenQuanitiesOnly ? 2 : 0} evenQuanitiesOnly={product.evenQuanitiesOnly} initialQty={product.evenQuanitiesOnly ? 2 : 1} setQty={this.setQty}/>
                    <Buttons>
                      <CommerceButton onClick={() => this.onAddCartClick(product)}>
                        Add
                      </CommerceButton>
                      {!isEmpty(product.config) ? (
                        <CommerceButton
                          onClick={() => onOpenCustomizeModalClicked(product)}
                        >
                          Custom
                        </CommerceButton>
                      ) : null}
                    </Buttons>
                  </>
                ) : (
                  <>
                    <CommerceButton
                      onClick={() => onOpenCustomizeModalClicked(product)}
                    >
                      Build your station
                    </CommerceButton>
                  </>
                )}
              </CommerceItems>
            </>
          }
        </ContentContainer>
      </ProductContainer>
    );
  }
}

const Title = styled.p`
  font-weight: 700;
  margin: 1em 0;
  color: #58585a;
`;

const CommerceItems = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: ${props => props.theme.responsive.small}) {
    height: 48px;
  }
`;

const ContentContainer = styled.div`
  padding: 0 1em 1em;
`;

const ProductImageContainer = styled.div`
  cursor: ${props => (props.showPointer ? 'pointer' : 'auto')};
`;

const ProductContainer = styled.div`
  overflow: hidden;
  min-width: 265px;

  img {
    backface-visibility: hidden; /* prevent jump effect when scaling */
  }

  &:hover {
    box-shadow: ${props => (props.disabled ? 'none' : '0 2px 16px 0 rgba(0, 0, 0, 0.1)')};

    img {
      transition: ${props => (props.disabled ? 'none' : 'transform 0.6s !important')};
      transform: ${props => (props.disabled ? 'none' : 'scale(1.1)')};
    }
  }
`;

const Description = styled.div`
  margin-bottom: 1em;
`;

const Price = styled.p`
  margin-bottom: 0.5em;
`;

export default Product;
